import { CANVAS_GRID_PX } from "../../lib/canvas-coordinates";
import { useCanvasRect } from "./use-canvas-rect";

// キャンバス面（白い用紙）とグリッド点を、現在のキャンバス矩形（サイズプリセットに応じた原点＋寸法）へ描画する。
// 中(10K)は原点 (0,0)、小は内側、大は原点が負値で外側へ広がる。矩形の外側（キャンバス外）には面もグリッドも
// 描かない（当初仕様どおり、図形はキャンバス外にも置けるが用紙・グリッドは矩形内のみ）。
//
// 各点をひとつずつ描画するのではなく、CSS の radial-gradient と background-size を使いパフォーマンスを稼ぐ。
// stage の transform: scale に対しても合成的に変形する。
export function CanvasGrid(): JSX.Element {
  const rect = useCanvasRect();
  // グリッド点を全体の 20px スナップ格子（ステージ座標の 20 の倍数）に載せるための位相補正。
  // 矩形原点が 20 の倍数でない（大サイズ等）場合でも、点がスナップ位置に一致するようずらす。
  const phaseX = ((rect.x % CANVAS_GRID_PX) + CANVAS_GRID_PX) % CANVAS_GRID_PX;
  const phaseY = ((rect.y % CANVAS_GRID_PX) + CANVAS_GRID_PX) % CANVAS_GRID_PX;
  return (
    <div
      aria-hidden
      style={{
        position: "absolute",
        left: `${rect.x}px`,
        top: `${rect.y}px`,
        width: `${rect.w}px`,
        height: `${rect.h}px`,
        pointerEvents: "none",
        backgroundColor: "var(--color-surface)",
        boxShadow: "0 0 0 1px var(--color-border)",
        backgroundImage:
          "radial-gradient(circle, var(--color-grid-dot) 1px, transparent 1px)",
        backgroundSize: `${CANVAS_GRID_PX}px ${CANVAS_GRID_PX}px`,
        // radial-gradient は位置省略時タイル中央にドットを描くため、そのままではドットが半セルずれる。
        // タイル原点を半セル分ずらし、さらに矩形原点の位相を補正して、ドット中心を 20 の倍数格子上へ載せる。
        backgroundPosition: `${-CANVAS_GRID_PX / 2 - phaseX}px ${-CANVAS_GRID_PX / 2 - phaseY}px`,
      }}
    />
  );
}
